import React from "react";
import "./Home.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Carousel from "react-bootstrap/Carousel";
import { useSelector } from "react-redux";
import Categories from "../components/Categories";
import FeaturedProducts from "../components/FeaturedProducts";
import axios from "axios";

function Home() {
  const showLogModal = useSelector((state) => {
    return state.showLogModal;
  });

  const handleReset = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/reset`
      );
      console.log(response);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div className="container-fluid bg-white px-0">
        <div id="carousel-div" className="row wow fadeInRight">
          <Carousel className="p-0">
            <Carousel.Item>
              <div
                className="w-100 d-flex flex-column justify-content-center align-items-center"
                style={{
                  background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url("https://laderach.com/media/wysiwyg/slide1.jpeg")`,
                  backgroundPosition: `center center`,
                  backgroundSize: `cover`,
                  backgroundRepeat: `no-repeat`,
                  height: `50vh`,
                }}
              >
                <h3 className="carouselTextTitle">
                  Fresh pralines and truffles
                </h3>
                <p>
                  <span className="carouselText">
                    Creating sweet moments of joy.
                  </span>
                </p>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div
                className="w-100 d-flex flex-column justify-content-center align-items-center"
                style={{
                  background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url("https://laderach.com/media/wysiwyg/slide2.jpeg")`,
                  backgroundPosition: `center center`,
                  backgroundSize: `cover`,
                  backgroundRepeat: `no-repeat`,
                  height: `50vh`,
                }}
              >
                <h3 className="carouselTextTitle">
                  The original: FrischSchoggi
                </h3>
                <p>
                  <span className="carouselText">
                    Exclusive chocolate for every tase.
                  </span>
                </p>
              </div>
            </Carousel.Item>
          </Carousel>
        </div>
        <div
          className="d-flex align-items-center text-white wow fadeInRight m-0 p-0"
          style={{ backgroundColor: `rgb(213, 179, 117)`, height: `8vh` }}
        >
          <div id="brown-bar-div" className="container d-flex">
            <div className="col homePinkBar d-flex justify-content-start">
              <span>
                <i className="fa-solid fa-circle-check"></i> Use of high-quality
                ingredients
              </span>
            </div>
            <div className="col homePinkBar">
              <span>
                <i className="fa-solid fa-circle-check"></i> Carefully crafted
                from bean to bar
              </span>
            </div>
            <div className="col homePinkBar d-flex justify-content-end">
              <span>
                <i className="fa-solid fa-circle-check"></i> Exclusively made in
                Switzerland
              </span>
            </div>
          </div>
        </div>
        <FeaturedProducts />
        <Categories />
        {/* <button onClick={handleReset}>ResetDB</button> */}
      </div>
    </>
  );
}

export default Home;
